// Permission display names (German)
export const PERMISSION_LABELS: Record<string, string> = {
    READ_PATIENT_MEDICAL_RECORD: 'Patientenakte lesen',
    WRITE_PATIENT_MEDICAL_RECORD: 'Patientenakte bearbeiten',
    DELETE_PATIENT_MEDICAL_RECORD: 'Patientenakte löschen',
    READ_PATIENT_BLOOD_RESULTS: 'Blutergebnisse lesen',
    WRITE_PATIENT_BLOOD_RESULTS: 'Blutergebnisse bearbeiten',
    READ_INVOICES: 'Rechnungen lesen',
    WRITE_INVOICES: 'Rechnungen bearbeiten',
    READ_APPOINTMENTS: 'Termine lesen',
    WRITE_APPOINTMENTS: 'Termine bearbeiten',
    READ_CUSTOMERS: 'Kunden lesen',
    WRITE_CUSTOMERS: 'Kunden bearbeiten',
    MANAGE_PERMISSIONS: 'Berechtigungen verwalten',
    MANAGE_USERS: 'Benutzer verwalten',
    MANAGE_ROLES: 'Rollen verwalten',
};

// Group permissions by category
export const PERMISSION_GROUPS: Record<string, string[]> = {
    'Patientenakte': [
        'READ_PATIENT_MEDICAL_RECORD',
        'WRITE_PATIENT_MEDICAL_RECORD',
        'DELETE_PATIENT_MEDICAL_RECORD',
    ],
    'Blutergebnisse': [
        'READ_PATIENT_BLOOD_RESULTS',
        'WRITE_PATIENT_BLOOD_RESULTS',
    ],
    'Rechnungen': [
        'READ_INVOICES',
        'WRITE_INVOICES',
    ],
    'Termine': [
        'READ_APPOINTMENTS',
        'WRITE_APPOINTMENTS',
    ],
    'Kunden': [
        'READ_CUSTOMERS',
        'WRITE_CUSTOMERS',
    ],
    'Administration': [
        'MANAGE_PERMISSIONS',
        'MANAGE_USERS',
        'MANAGE_ROLES',
    ],
};
